import yall from "yall-js";

export function useLazyLoading() {
    yall({
        observeChanges: true,
    });
}